import { Route } from "react-router-dom";
import Invoices from "./Invoices";
import List from "./List";
import InvoicesPage from "./InvoicesPage";
import AddOdooAccount from "./AddOdooAccount";
import EditOdooAccount from "./EditOdooAccount";

export default (
  <Route path="odoo" exact element={<Invoices />}>
    <Route index element={<InvoicesPage />} />
    <Route path=":name" element={<List />} />
    <Route path="OdooAccounts/add/:name" element={<AddOdooAccount />} />
    <Route path="OdooAccounts/edit/:id/:name" element={<EditOdooAccount />} />
  </Route>
);
